<template>
    <div>
    <a class="skip-to-content-link" href="#main">
        Skip to content
    </a>
    <main class="mixology" id="main">
        <navigation class="mixology__nav" />
        <h1 class="mixology__title"> {{mixologyData.TITLE}}</h1>
        <mix-header class="mixology__header"/>
        <filters :filtersList="getAgeGatedFilters"/>
        <div class="mixology__showcase-tiles-container">
            <showcase-window :recipe="getFilteredList[getActiveRecipe]" :cta="mixologyData.CTA"></showcase-window>
            <tiles-container :recipes="getFilteredList"></tiles-container>
        </div>
    </main>
    </div>
</template>

<script>
import Navigation from '@/components/Navigation';
import mixologyData from "./../../static/libs/mixology";
import recipeJson from "./../../static/libs/recipes.json";
import { mapGetters, mapActions } from "vuex";
import MixHeader from '@/components/mixology/MixHeader'
import ShowcaseWindow from "@/components/mixology/ShowcaseWindow";
import TilesContainer from "@/components/mixology/TilesContainer";
import Filters from "@/components/mixology/Filters";

export default {
    name: "mixology-page",
    computed: mapGetters(["getActiveRecipe", "getFilteredList", "getAgeGatedFilters"]),
    components: {
        Navigation,
        MixHeader,
        ShowcaseWindow,
        TilesContainer,
        Filters
    },
    methods:{
        ...mapActions(["setInitalList"]),

    },
    async mounted() {
        this.setInitalList(JSON.parse(window.sessionStorage.getItem("ofAge")));
    },
    data() {
        return {
            mixologyData,
            recipeJson,
        };
    }
};
</script>

<style lang="scss" scoped>
  @import './../variables';
    
    .mixology {
        min-height: calc(100vh);
        background-color: $bubly-blue-light;
        &__nav{
            background-color: #fff ;
            @media(min-width: 768px){
                position: fixed;
                top: 0;
                width: 100vw;
                z-index: 1000;
            };

        }
        &__title{
            position: fixed;
            width: 1px;
            height: 1px;
            overflow: hidden;
            margin: 0;
            padding: 0;
        }

        &__header {
            position: relative;
            @media(min-width: 768px){
                // position: fixed;
            }

        }

        &__showcase-tiles-container {
            display: flex;
            justify-content: flex-end;

            @media(min-width: 768px){
                // margin-top: 358px;

            }
        }
    }

    
</style>


// WEBPACK FOOTER //
// src/pages/MixologyPage.vue